"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardRenderItemType_1 = require("@/common/cards/render/CardRenderItemType");
const AltSecondaryTag_1 = require("@/common/cards/render/AltSecondaryTag");
const Size_1 = require("@/common/cards/render/Size");
const Types_1 = require("@/common/cards/render/Types");
const CardResource_1 = require("@/common/CardResource");
exports.default = vue_1.default.extend({
    name: 'CardRenderItemComponent',
    props: {
        item: {
            type: Object,
        },
    },
    methods: {
        sized(clazz, size) {
            return size !== undefined ? `${clazz}--${size}` : clazz;
        },
    },
    computed: {
        resourceClass() {
            if (this.item.resource === undefined) {
                return '';
            }
            if (this.item.resource === CardResource_1.CardResource.RESOURCE_CUBE) {
                return 'card-resource-cube';
            }
            return 'card-resource-' + this.item.resource.toLowerCase().replaceAll(' ', '-');
        },
        resourceSizeClass() {
            if (this.item.size !== undefined) {
                return 'card-resource-size--' + this.item.size;
            }
            return '';
        },
        tagClass() {
            if (this.item.tag === undefined) {
                return '';
            }
            return 'card-tag-' + this.item.tag.toLowerCase().replaceAll(' ', '-');
        },
        componentClasses() {
            const classes = [];
            if (this.item.isSuperscript) {
                classes.push('card-superscript');
            }
            classes.push(...this.componentClassArray);
            if (this.item.secondaryTag === AltSecondaryTag_1.AltSecondaryTag.NO_PLANETARY_TAG) {
                classes.push('tag-clone');
            }
            if (this.item.anyPlayer === true) {
                const type = this.item.type;
                if (type === CardRenderItemType_1.CardRenderItemType.DELEGATES) {
                    classes.push('card-delegate-red');
                }
                else if (type === CardRenderItemType_1.CardRenderItemType.CHAIRMAN) {
                    classes.push('card-chairman-red');
                }
                else {
                    classes.push('red-outline');
                }
            }
            if (this.item.isPlate) {
                classes.push('card-plate');
                if (this.item.size === Size_1.Size.SMALL) {
                    classes.push('card-plate--narrow');
                }
            }
            if (this.item.text !== undefined) {
                classes.push(`card-text-size--${this.item.size}`);
                if (this.item.isUppercase) {
                    classes.push('card-text-uppercase');
                }
                if (this.item.isBold) {
                    classes.push('card-text-bold');
                }
                else {
                    classes.push('card-text-normal');
                }
            }
            return classes;
        },
        componentClassArray() {
            let cardResource = 'card-resource';
            if (this.item.secondaryTag) {
                cardResource = 'card-resource--has-secondary-tag';
            }
            else if (this.item.isSuperscript) {
                cardResource = 'card-resource--superscript';
            }
            switch (this.item.type) {
                case CardRenderItemType_1.CardRenderItemType.TEMPERATURE:
                    return ['card-global-requirement', 'card-temperature-global-requirement'];
                case CardRenderItemType_1.CardRenderItemType.OXYGEN:
                    return ['card-global-requirement', 'card-oxygen-global-requirement'];
                case CardRenderItemType_1.CardRenderItemType.OCEANS:
                    if (this.item.size !== undefined && this.item.size !== Size_1.Size.MEDIUM) {
                        return ['card-global-requirement', 'card-ocean-global-requirement', `card-ocean--${this.item.size}`];
                    }
                    else {
                        return ['card-global-requirement', 'card-ocean-global-requirement'];
                    }
                case CardRenderItemType_1.CardRenderItemType.VENUS:
                    return ['card-global-requirement', 'card-venus-global-requirement'];
                case CardRenderItemType_1.CardRenderItemType.TR:
                    if (this.item.size !== undefined && this.item.size !== Size_1.Size.MEDIUM) {
                        return ['card-tile', 'card-tr', `card-tr--${this.item.size}`];
                    }
                    else {
                        return ['card-tile', 'card-tr'];
                    }
                case CardRenderItemType_1.CardRenderItemType.TITANIUM:
                    return [cardResource, 'card-resource-titanium'];
                case CardRenderItemType_1.CardRenderItemType.STEEL:
                    return [cardResource, 'card-resource-steel'];
                case CardRenderItemType_1.CardRenderItemType.HEAT:
                    return [cardResource, 'card-resource-heat'];
                case CardRenderItemType_1.CardRenderItemType.ENERGY:
                    return [cardResource, 'card-resource-energy'];
                case CardRenderItemType_1.CardRenderItemType.PLANTS:
                    return [cardResource, 'card-resource-plant'];
                case CardRenderItemType_1.CardRenderItemType.MEGACREDITS:
                    if (this.item.size !== undefined && this.item.size !== Size_1.Size.MEDIUM) {
                        return [cardResource, 'card-resource-money', `card-money--${this.item.size}`];
                    }
                    else {
                        return [cardResource, 'card-resource-money'];
                    }
                case CardRenderItemType_1.CardRenderItemType.CARDS:
                    return [cardResource, 'card-card'];
                case CardRenderItemType_1.CardRenderItemType.WILD:
                    if (this.item.cancelled === true) {
                        return [cardResource, 'card-resource-wild', 'card-private-security'];
                    }
                    else {
                        return [cardResource, 'card-resource-wild'];
                    }
                case CardRenderItemType_1.CardRenderItemType.ONE:
                    return [cardResource, 'card-resource-one'];
                case CardRenderItemType_1.CardRenderItemType.DIVERSE_TAG:
                    return ['card-resource-tag', 'card-resource-diverse'];
                case CardRenderItemType_1.CardRenderItemType.TRADE:
                    if (this.item.size === Size_1.Size.SMALL) {
                        return ['card-resource-trade', 'card-resource-colony--S'];
                    }
                    else {
                        return ['card-resource-trade'];
                    }
                case CardRenderItemType_1.CardRenderItemType.COLONIES:
                    if (this.item.size === Size_1.Size.SMALL) {
                        return ['card-resource-colony', 'card-resource-colony--S'];
                    }
                    else {
                        return ['card-resource-colony'];
                    }
                case CardRenderItemType_1.CardRenderItemType.TRADE_DISCOUNT:
                case CardRenderItemType_1.CardRenderItemType.MULTIPLIER_WHITE:
                    return [cardResource, 'card-resource-trade-discount'];
                case CardRenderItemType_1.CardRenderItemType.TRADE_FLEET:
                    return ['card-resource-trade-fleet'];
                case CardRenderItemType_1.CardRenderItemType.CHAIRMAN:
                    return ['card-chairman'];
                case CardRenderItemType_1.CardRenderItemType.PARTY_LEADERS:
                    return ['card-party-leader'];
                case CardRenderItemType_1.CardRenderItemType.DELEGATES:
                    return ['card-delegate'];
                case CardRenderItemType_1.CardRenderItemType.INFLUENCE:
                    return ['card-influence', `card-influence--size-${this.item.size}`];
                case CardRenderItemType_1.CardRenderItemType.NO_TAGS:
                    return ['card-resource-tag', 'card-no-tags'];
                case CardRenderItemType_1.CardRenderItemType.EMPTY_TAG:
                    return ['card-resource-tag', 'card-tag-empty'];
                case CardRenderItemType_1.CardRenderItemType.CITY:
                    return ['card-tile', `city-tile--${this.item.size}`];
                case CardRenderItemType_1.CardRenderItemType.GREENERY:
                    if (this.item.secondaryTag === AltSecondaryTag_1.AltSecondaryTag.OXYGEN) {
                        return ['card-tile', `greenery-tile-oxygen--${this.item.size}`];
                    }
                    else {
                        return ['card-tile', `greenery-tile--${this.item.size}`];
                    }
                case CardRenderItemType_1.CardRenderItemType.EMPTY_TILE:
                    if (this.item.size !== undefined) {
                        return ['card-tile-ares', `board-space-tile--empty-tile--${this.item.size}`];
                    }
                    else {
                        return ['card-tile-ares'];
                    }
                case CardRenderItemType_1.CardRenderItemType.EMPTY_TILE_GOLDEN:
                    return ['card-tile-ares', 'board-space-tile--adjacency-tile'];
                case CardRenderItemType_1.CardRenderItemType.EMPTY_TILE_SPECIAL:
                    if (this.item.size !== undefined) {
                        return ['card-tile', `special-tile--${this.item.size}`];
                    }
                    else {
                        return ['card-tile', 'special-tile'];
                    }
                case CardRenderItemType_1.CardRenderItemType.CITY_OR_SPECIAL_TILE:
                    return ['card-tile', 'city-or-special-tile'];
                case CardRenderItemType_1.CardRenderItemType.COMMUNITY:
                    return [cardResource, 'card-resource-community'];
                case CardRenderItemType_1.CardRenderItemType.MOON_HABITAT:
                    if (this.item.secondaryTag === AltSecondaryTag_1.AltSecondaryTag.MOON_HABITAT_RATE) {
                        return [this.sized('card-tile-lunar-habitat-rate', this.item.size)];
                    }
                    else {
                        return [this.sized('card-tile-lunar-habitat', this.item.size)];
                    }
                case CardRenderItemType_1.CardRenderItemType.GLOBAL_EVENT:
                    return ['turmoil-global-event'];
                case CardRenderItemType_1.CardRenderItemType.POLICY:
                    return ['turmoil-policy-tile'];
                case CardRenderItemType_1.CardRenderItemType.ARROW_OPG:
                    return ['card-arrow-opg'];
                case CardRenderItemType_1.CardRenderItemType.REDS:
                    return ['card-reds'];
                case CardRenderItemType_1.CardRenderItemType.REDS_DEACTIVATED:
                    return ['card-reds-deactivated'];
                case CardRenderItemType_1.CardRenderItemType.ADJACENCY_BONUS:
                    return ['card-adjacency-bonus'];
                case CardRenderItemType_1.CardRenderItemType.HAZARD_TILE:
                    if (this.item.size !== undefined && this.item.size !== Size_1.Size.MEDIUM) {
                        return [`card-hazard-tile--${this.item.size}`];
                    }
                    else {
                        return ['card-hazard-tile'];
                    }
                case CardRenderItemType_1.CardRenderItemType.MOON_HABITAT_RATE:
                    if (this.item.size !== undefined) {
                        return ['card-habitat-rate', `card-habitat-rate--${this.item.size}`];
                    }
                    else {
                        return ['card-habitat-rate'];
                    }
                case CardRenderItemType_1.CardRenderItemType.MOON_MINE:
                    if (this.item.secondaryTag === AltSecondaryTag_1.AltSecondaryTag.MOON_MINING_RATE) {
                        return [this.sized('card-tile-lunar-mine-rate', this.item.size)];
                    }
                    else {
                        return [this.sized('card-tile-lunar-mine', this.item.size)];
                    }
                case CardRenderItemType_1.CardRenderItemType.MOON_MINING_RATE:
                    if (this.item.size !== undefined) {
                        return ['card-mining-rate', `card-mining-rate--${this.item.size}`];
                    }
                    else {
                        return ['card-mining-rate'];
                    }
                case CardRenderItemType_1.CardRenderItemType.MOON_ROAD:
                    if (this.item.secondaryTag === AltSecondaryTag_1.AltSecondaryTag.MOON_LOGISTICS_RATE) {
                        return [this.sized('card-tile-lunar-road-rate', this.item.size)];
                    }
                    else {
                        return [this.sized('card-tile-lunar-road', this.item.size)];
                    }
                case CardRenderItemType_1.CardRenderItemType.MOON_LOGISTICS_RATE:
                    if (this.item.size !== undefined) {
                        return ['card-logistics-rate', `card-logistics-rate--${this.item.size}`];
                    }
                    else {
                        return ['card-logistics-rate'];
                    }
                case CardRenderItemType_1.CardRenderItemType.PLANETARY_TRACK:
                    return ['card-planetary-track'];
                case CardRenderItemType_1.CardRenderItemType.CATHEDRAL:
                    return [cardResource, 'card-resource-cathedral'];
                case CardRenderItemType_1.CardRenderItemType.NOMADS:
                    return [cardResource, 'card-resource-nomads'];
                case CardRenderItemType_1.CardRenderItemType.IDENTIFY:
                    return ['card-identification'];
                case CardRenderItemType_1.CardRenderItemType.EXCAVATE:
                    return [this.item.isSuperscript ? 'card-excavation--superscript' : 'card-excavation'];
                case CardRenderItemType_1.CardRenderItemType.CORRUPTION:
                    return [cardResource, 'card-resource-corruption'];
                case CardRenderItemType_1.CardRenderItemType.RESOURCE:
                    return [cardResource, this.resourceClass, this.resourceSizeClass];
                case CardRenderItemType_1.CardRenderItemType.TAG:
                    return ['card-resource-tag', this.tagClass];
                case CardRenderItemType_1.CardRenderItemType.NEUTRAL_DELEGATE:
                    return ['card-neutral-delegate'];
                case CardRenderItemType_1.CardRenderItemType.UNDERGROUND_RESOURCES:
                    return ['card-underground-resources'];
                case CardRenderItemType_1.CardRenderItemType.CORRUPTION_SHIELD:
                    return ['card-corruption-shield'];
                case CardRenderItemType_1.CardRenderItemType.GEOSCAN_ICON:
                    return ['card-geoscan-icon'];
                case CardRenderItemType_1.CardRenderItemType.UNDERGROUND_SHELTERS:
                    return ['card-underground-shelters'];
                default:
                    return [];
            }
        },
        amountAbs() {
            if (this.item.amountInside)
                return 1;
            return Math.abs(this.item.amount);
        },
        itemsToShow() {
            if (this.item.showDigit)
                return 1;
            return this.amountAbs;
        },
        itemHtmlContent() {
            let result = '';
            if ((0, Types_1.isICardRenderItem)(this.item)) {
                if (this.item.innerText) {
                    result += this.item.innerText;
                }
                else if (this.item.amountInside) {
                    if (this.item.amount !== 0) {
                        result += this.item.amount.toString();
                    }
                    if (this.item.clone) {
                        result += '<div style="-webkit-filter: greyscale(100%);filter: grayscale(100%)">🪐</div>';
                    }
                }
            }
            const previouslyRendered = [
                AltSecondaryTag_1.AltSecondaryTag.OXYGEN,
                AltSecondaryTag_1.AltSecondaryTag.MOON_HABITAT_RATE,
                AltSecondaryTag_1.AltSecondaryTag.MOON_MINING_RATE,
                AltSecondaryTag_1.AltSecondaryTag.MOON_LOGISTICS_RATE,
            ];
            const secondaryTag = this.item.secondaryTag;
            if (secondaryTag !== undefined && !previouslyRendered.includes(secondaryTag)) {
                result += '<div class="card-icon card-tag-' + secondaryTag + '"></div>';
            }
            if (this.item.isPlate || this.item.text !== undefined) {
                result += this.item.text || 'n/a';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.MULTIPLIER_WHITE) {
                result = 'X';
            }
            else if (this.item.type === CardRenderItemType_1.CardRenderItemType.IGNORE_GLOBAL_REQUIREMENTS) {
                result += '<div class="card-project-requirements">';
                result += '<div class="card-x">x</div>';
                result += '<div class="card-requirements">Global Requirements</div>';
                result += '</div>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.SELF_REPLICATING) {
                result = '<div class="card-resource card-card"><div class="cards-count">2</div><div class="card-icon card-icon-space">✴</div><div class="card-icon card-icon-building">☗</div></div>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.COLONY_TILE) {
                result = '<span class="card-colony-tile">colony</span>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.PRELUDE) {
                result = '<div class="card-prelude-container"><span class="card-prelude-icon">prel</span></div>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.CORPORATION) {
                result = '<div class="card-corporation-icon"></div>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.FIRST_PLAYER) {
                result = '<div class="card-first-player-icon"></div>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.RULING_PARTY) {
                result = '<div class="card-party-icon"></div>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.AWARD) {
                result = '<span class="card-award-icon">award</span>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.MILESTONE) {
                result = '<span class="card-award-icon">milestone</span>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.VP) {
                result = '<div class="card-resource points-big card-vp-questionmark">?</div>';
            }
            if (this.item.type === CardRenderItemType_1.CardRenderItemType.MEGACREDITS && this.item.amount === undefined) {
                result = '?';
            }
            if (this.item.cancelled === true) {
                switch (this.item.type) {
                    case CardRenderItemType_1.CardRenderItemType.TR:
                    case CardRenderItemType_1.CardRenderItemType.WILD:
                    case CardRenderItemType_1.CardRenderItemType.UNDERGROUND_RESOURCES:
                    case CardRenderItemType_1.CardRenderItemType.TRADE:
                        result = '<div class="card-x">x</div>';
                }
            }
            return result;
        },
    },
});
